import { memo } from "react";
import Image from "next/image";
import Box from "@mui/material/Box";
import { useRouter } from "next/router";

const LEASING_ROUTE = "/partnership/leasing-partners";

const WRAPPER_SX = {
  width: "100%",
  height: "100%",
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const LOGO_WRAPPER_SX = {
  position: "relative",
  width: "100px",
  height: "56px",
  top: "-30px",
};

function BackGround() {
  const router = useRouter();

  const isContactNowMerchant = router.pathname === LEASING_ROUTE;

  if (!isContactNowMerchant) {
    return null;
  }

  return (
    <Box sx={WRAPPER_SX}>
      <Box sx={LOGO_WRAPPER_SX}>
        <Image
          src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-now.webp"
          alt="Contact Now Merchant"
          fill
          sizes="100px"
          style={{ objectFit: "contain" }}
        />
      </Box>
    </Box>
  );
}

export default memo(BackGround);